import { getAccessToken } from "@/utils/functions/cookieOperations";
import { atom } from "jotai";

export const isSignedInAtom = atom(!!getAccessToken());
